import React from "react";
import "./refundAndCancellationPolicy.scss";

const RefundAndCancellationPolicy = () => {
  return (
    <div className="refund-and-cancellation-policy">
      <div className="title">Refund And Cancellation Policy</div>
      <div className="main-container">
        <div>
          <div>
            <strong>Last updated on:</strong> Sep 14, 2025
          </div>
          <div>
            At KRISTIVE, we aim to ensure your satisfaction with every purchase.
            Please review our refund and cancellation policy:
          </div>
        </div>
        <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
          <div>
            KRISTIVE believes in helping its customers as far as possible, and
            has therefore a liberal cancellation policy. Under this policy:
          </div>
          <div>
            Cancellations will be considered only if the request is made within
            2 days of placing the order. However, the cancellation request may
            not be entertained if the orders have been communicated to the
            vendors/merchants and they have initiated the process of shipping
            them.
          </div>
          <div>
            KRISTIVE does not accept cancellation requests for perishable items
            like flowers, eatables etc. However, refund/replacement can be made
            if the customer establishes that the quality of product delivered is
            not good.
          </div>
          <div>
            In case of receipt of damaged or defective items please report the
            same to our Customer Service team. The request will, however, be
            entertained once the merchant has checked and determined the same at
            his own end. This should be reported within 2 days of receipt of the
            products.
          </div>
          <div>
            In case you feel that the product received is not as shown on the
            site or as per your expectations, you must bring it to the notice of
            our customer service within 2 days of receiving the product. The
            Customer Service Team after looking into your complaint will take an
            appropriate decision.
          </div>
          <div>
            In case of complaints regarding products that come with a warranty
            from manufacturers, please refer the issue to them.
          </div>
          <div>
            In case of any Refunds approved by the KRISTIVE, it'll take 3-5 days
            for the refund to be processed to the end customer.
          </div>
        </div>
      </div>
    </div>
  );
};

export default RefundAndCancellationPolicy;
